import { PA_VALUE_FIELDS } from "../types/product-attribute/product-attribute";
import { deepCopy } from "../utils/common";

const mapBookingAttributes = (
  attributes: BookingAttributeDTO[],
): BookingAttributeDTO[] => {
  return (attributes ?? [])
    .filter((x) =>
      PA_VALUE_FIELDS.includes(x.productAttribute.name as ProdValueField),
    )
    .map((x) => ({
      ...x,
      productAttribute: {
        id: x.productAttribute?.id,
        value: x.productAttribute?.value,
        name: x.productAttribute?.name,
        type: x.productAttribute?.type,
      },
    }));
};

const mapBookingDetailResponseDTO = (
  dto: BookingDetailResponseDTO,
): BookingState => {
  return {
    bookingDetailId: dto.id,
    product: dto.product,
    bookingAttributes: mapBookingAttributes(dto.bookingAttributes ?? []),
    updatedAt: Date.now(),
    status: dto.status,
    canEdit: dto.canEdit,
    canCancel: dto.canCancel,
    lastUpdatedAt: dto.lastUpdatedAt,
  };
};

export const mappingResponseDTO2BookingState = (
  dto?: BookingResponseDTO,
): BookingState | undefined => {
  if (!dto) return;

  const product = dto.product;
  const isPassProduct = product?.productType === "PASS";
  const childrenLsFull = dto.bookingDetails.map(mapBookingDetailResponseDTO);
  const childrenLs = isPassProduct
    ? childrenLsFull
        // product bị cancel thì không hiển thị
        .filter((x) => x.status?.toUpperCase() !== "CANCEL")
    : [];
  const canceledProductIds: number[] = ((dto.bookingDetails ?? [])
    .map(mapBookingDetailResponseDTO)
    // product bị cancel thì không hiển thị
    .filter((x) => x.status?.toUpperCase() === "CANCEL")
    .map((x) => x.product?.id)
    .filter((x) => !!x) ?? []) as number[];
  const defaultOne = isPassProduct ? dto : dto.bookingDetails[0];
  if (defaultOne) {
    const a = {
      status: dto.status,
      bookTime: dto.bookTime,
      ...mapBookingDetailResponseDTO(defaultOne),
      price: dto.price,
      changeStatus: dto.changeStatus,
      isEdit: dto.isEdit,
      isUpgrade: dto.isUpgrade,
      id: dto.id,
      bookGroupNo: dto?.bookGroupNo,
      bookNo: dto.bookNo,
      changeRequest: mappingResponseDTO2BookingState(dto.changeRequest),
      childrenLs,
      childrenLsFull,
      canceledProductIds,
      user: dto.user,
      customerType: dto.customer?.customerType,
    };
    const clone = deepCopy(a);
    return {
      ...a,
      prevBookingState: toPrevBookingState(clone),
    };
  }
};

export const toPrevBookingState = (booking: BookingState): BookingState => {
  return {
    ...booking,
    isPrev: true,
    childrenLs:
      booking.childrenLs?.map((x) => ({
        ...x,
        isPrev: true,
      })) ?? [],
    prevBookingState: undefined,
  };
};
